import { useState, useEffect } from 'react'

const INST_API = '/cms/api/institutions'

export default function InstBannerManagePage() {
  const [institutions, setInstitutions] = useState([])
  const [selectedId, setSelectedId] = useState('')
  const [config, setConfig] = useState(null)
  const [banners, setBanners] = useState([])
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [editingIdx, setEditingIdx] = useState(-1)
  const [form, setForm] = useState({ title: '', image: '', link: '', sort: 1 })

  // 加载机构列表
  useEffect(() => {
    fetch(`${INST_API}?status=active&_t=${Date.now()}`)
      .then(r => r.json())
      .then(d => {
        const list = d.data || d || []
        setInstitutions(list)
        if (list.length > 0 && !selectedId) setSelectedId(list[0].id)
      })
      .catch(() => setMessage('加载机构列表失败'))
  }, [])

  // 加载机构小程序配置中的轮播图
  useEffect(() => {
    if (!selectedId) return
    setLoading(true)
    fetch(`${INST_API}/${selectedId}/miniapp-config`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          setConfig(d.data)
          setBanners(d.data.banners || [])
        } else {
          setConfig(null)
          setBanners([])
        }
        setLoading(false)
      })
      .catch(() => { setConfig(null); setBanners([]); setLoading(false) })
  }, [selectedId])

  // 保存轮播图到机构配置
  const saveBanners = async (newBanners) => {
    setSaving(true)
    try {
      const r = await fetch(`${INST_API}/${selectedId}/miniapp-config`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ banners: newBanners })
      })
      const d = await r.json()
      if (d.success) {
        setBanners(newBanners)
        setMessage('✅ 轮播图已保存')
      } else {
        setMessage('❌ 保存失败: ' + (d.error || ''))
      }
    } catch {
      setMessage('❌ 网络错误')
    }
    setSaving(false)
    setTimeout(() => setMessage(''), 3000)
  }

  const openAdd = () => {
    setEditingIdx(-1)
    setForm({ title: '', image: '', link: '', sort: banners.length + 1 })
    setShowModal(true)
  }

  const openEdit = (idx) => {
    setEditingIdx(idx)
    setForm({ ...banners[idx] })
    setShowModal(true)
  }

  const handleSave = () => {
    if (!form.title) { setMessage('⚠️ 请填写标题'); setTimeout(() => setMessage(''), 2000); return }
    if (!form.image) { setMessage('⚠️ 请填写图片URL'); setTimeout(() => setMessage(''), 2000); return }
    let newBanners
    if (editingIdx >= 0) {
      newBanners = [...banners]
      newBanners[editingIdx] = form
    } else {
      newBanners = [...banners, { ...form, id: Date.now() }]
    }
    saveBanners(newBanners)
    setShowModal(false)
  }

  const handleDelete = (idx) => {
    if (!confirm('确定删除这张轮播图？')) return
    const newBanners = banners.filter((_, i) => i !== idx)
    saveBanners(newBanners)
  }

  const move = (idx, dir) => {
    const newIdx = idx + dir
    if (newIdx < 0 || newIdx >= banners.length) return
    const newBanners = [...banners]
    ;[newBanners[idx], newBanners[newIdx]] = [newBanners[newIdx], newBanners[idx]]
    newBanners.forEach((b, i) => b.sort = i + 1)
    saveBanners(newBanners)
  }

  const selStyle = { width: '100%', maxWidth: 400, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, marginBottom: 20 }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ margin: '0 0 4px' }}>🖼 机构轮播图管理</h2>
          <p style={{ color: '#666', margin: 0, fontSize: 14 }}>管理各机构小程序的首页轮播图</p>
        </div>
        {!loading && selectedId && (
          <button onClick={openAdd} style={{ padding: '10px 20px', background: '#667eea', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
            ➕ 添加轮播图
          </button>
        )}
      </div>

      {message && (
        <div style={{ padding: '10px 16px', background: message.startsWith('✅') ? '#f6ffed' : message.startsWith('⚠️') ? '#fffbe6' : '#fff2e8', border: `1px solid ${message.startsWith('✅') ? '#b7eb8f' : message.startsWith('⚠️') ? '#ffe58f' : '#ffbb96'}`, borderRadius: 6, marginBottom: 16, color: message.startsWith('✅') ? '#389e0d' : message.startsWith('⚠️') ? '#ad8b00' : '#d46b08' }}>
          {message}
        </div>
      )}

      <select value={selectedId} onChange={e => setSelectedId(e.target.value)} style={selStyle}>
        {institutions.map(i => (
          <option key={i.id} value={i.id}>{i.name || i.id} ({i.id})</option>
        ))}
      </select>

      {loading && <div style={{ color: '#999', padding: 20 }}>加载中...</div>}

      {!loading && selectedId && (
        <div style={{ display: 'grid', gap: 16 }}>
          {banners.sort((a, b) => (a.sort || 0) - (b.sort || 0)).map((banner, idx) => (
            <div key={banner.id || idx} style={{ background: '#fff', borderRadius: 12, padding: 16, display: 'flex', gap: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
              {banner.image ? (
                <img src={banner.image} alt={banner.title} style={{ width: 200, height: 120, objectFit: 'cover', borderRadius: 8 }} />
              ) : (
                <div style={{ width: 200, height: 120, background: '#f5f5f5', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ccc', fontSize: 32 }}>🖼</div>
              )}
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 8px' }}>{banner.title || '(无标题)'}</h3>
                <p style={{ color: '#666', margin: '0 0 8px', fontSize: 13 }}>
                  {banner.link ? `跳转: ${banner.link}` : '无跳转链接'}
                </p>
                <span style={{ color: '#999', fontSize: 12 }}>排序: #{banner.sort || idx + 1}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <button onClick={() => move(idx, -1)} disabled={idx === 0} style={{ padding: '6px 12px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: idx === 0 ? 'default' : 'pointer', opacity: idx === 0 ? 0.4 : 1 }}>⬆️</button>
                <button onClick={() => move(idx, 1)} disabled={idx === banners.length - 1} style={{ padding: '6px 12px', background: '#f0f0f0', border: 'none', borderRadius: 4, cursor: idx === banners.length - 1 ? 'default' : 'pointer', opacity: idx === banners.length - 1 ? 0.4 : 1 }}>⬇️</button>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <button onClick={() => openEdit(idx)} style={{ padding: '6px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>编辑</button>
                <button onClick={() => handleDelete(idx)} style={{ padding: '6px 16px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>删除</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && banners.length === 0 && selectedId && (
        <div style={{ textAlign: 'center', padding: 60, color: '#999', background: '#fff', borderRadius: 12 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📷</div>
          <p>该机构暂无轮播图，点击上方按钮添加</p>
        </div>
      )}

      {/* 弹窗 */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => setShowModal(false)}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 500, maxHeight: '80vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 20px' }}>{editingIdx >= 0 ? '✏️ 编辑轮播图' : '➕ 添加轮播图'}</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>标题 *</label>
              <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="如：暑期特惠活动" style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>图片URL *</label>
              <input value={form.image} onChange={e => setForm({ ...form, image: e.target.value })} placeholder="https://cdn.boxiaotu.cn/..." style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
              {form.image && <img src={form.image} alt="" style={{ marginTop: 8, width: '100%', maxHeight: 150, objectFit: 'cover', borderRadius: 8 }} />}
            </div>
            
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, color: '#666' }}>跳转链接（可选，小程序页面路径）</label>
              <input value={form.link} onChange={e => setForm({ ...form, link: e.target.value })} placeholder="如：/pages/study-tour/study-tour" style={{ width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
              <button onClick={() => setShowModal(false)} style={{ padding: '10px 24px', background: '#f0f0f0', border: 'none', borderRadius: 6, cursor: 'pointer' }}>取消</button>
              <button onClick={handleSave} style={{ padding: '10px 24px', background: '#667eea', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>保存</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
